var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Toasts'),_vm._v(" "),(_vm.canViewPage)?_c('PageContent',{attrs:{"path":_vm.path,"params":_vm.params,"elements":_vm.elements,"shared-elements":_vm.sharedElements}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }